import Modal from 'components/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../../components/Button';
import Loading from '../../../../components/Loading';
import SetCodeWordForm from './SetPasswordForm';
import { connect } from 'react-redux';
import submit from './private/submitValidation';
import { resetIsPrimaryPassword } from '../../redux/user/actions';
import errorMessages from 'constants/errorMessages';
import { makePwdSignConstant } from 'modules/Profile/services/API';
import Warning from 'components/Warning';
import 'modules/Taps/components/Forms/Buttons/styles.scss';

const steps = {
  main: 'main',
  setPermanentStatus: 'setPermanentStatus',
  currentPasswordConfirmed: 'currentPasswordConfirmed',
};

@connect(
  function ({ app: { user } }) {
    return { user };
  },
  (dispatch) => {
    return { updateInfo: () => dispatch(resetIsPrimaryPassword()) };
  },
)
export default class SetPasswordForm extends React.Component {
  static propTypes = {
    showModal: PropTypes.bool,
    onHideModal: PropTypes.func,
    updateInfo: PropTypes.func,
  };

  state = {
    loading: false,
    error: null,
    data: null,
    currentStep: steps.main,
  };

  setLoading = (loading) => {
    this.setState({ loading: loading });
  };
  setStep = (stepName) => {
    this.setState({ currentStep: stepName });
  };
  setError = (error) => {
    this.setState({ error: error });
  };
  handleSubmit = (data) => {
    const submitResult = submit(data);
    this.setState({ loading: true });
    submitResult
      .then(() => {
        this.props.updateInfo();
        this.setState({ loading: false });
      })
      .catch(() => this.setState({ loading: false }));
    return submitResult;
  };
  makePwdSignConstant = async () => {
    const result = await makePwdSignConstant();
    if (!result.isOk) {
      throw errorMessages.defaultServerError;
    }
  };
  handleClickConfirmCurrentPassword = async () => {
    this.setLoading(true);
    try {
      await this.makePwdSignConstant();
      this.setLoading(false);
      this.setStep(steps.currentPasswordConfirmed);
    } catch (e) {
      this.setError(e);
      this.setLoading(false);
    }
  };

  getMainStep = () => {
    return (
      <div>
        <h2>Задайте постоянный пароль</h2>
        <div className="profile_password js-add-block">
          <p>
            Измените первичный пароль либо подтвердите его дальнейшее использование. В целях
            безопасности ваших данных рекомендуем задать новый пароль. Повторно сменить пароль или
            указать контакты для восстановления пароля можно в разделе «Профиль».
          </p>
        </div>
        {this.state.error && <Warning message={this.state.error} />}
        <div className={'steps_button'}>
          {this.state.loading ? (
            <Loading isLight={true} />
          ) : (
            <>
              <Button
                buttonStyle={{ position: 'relative', minWidth: '210px' }}
                onClick={this.handleClickConfirmCurrentPassword}
                type="button"
                size="medium"
                color="orange"
                hasWrapper={false}
              >
                Подтвердить текущий
              </Button>
              <Button
                buttonStyle={{ position: 'relative', minWidth: '210px' }}
                onClick={() => this.setStep(steps.setPermanentStatus)}
                type="button"
                size="medium"
                color="orange"
                hasWrapper={false}
              >
                Задать новый
              </Button>
            </>
          )}
        </div>
      </div>
    );
  };
  getSetPermanentStatusStep = () => {
    return (
      <SetCodeWordForm
        onSubmit={this.handleSubmit}
        onSubmitFail={this.handleSubmitFailed}
        innerError={this.state.error}
        loading={this.state.loading}
      />
    );
  };
  getCurrentPasswordConfirmedStep = () => {
    return (
      <div>
        <h2 className="page_subtitle">{'Текущий пароль подтвержден.'}</h2>
      </div>
    );
  };
  isFinishedStep = () => {
    return this.state.currentStep === steps.currentPasswordConfirmed;
  };
  handleSubmitFailed = () => {
    this.setState({ error: errorMessages.defaultServerError });
  };
  renderSteps = (currentStep) => {
    switch (currentStep) {
      case steps.main:
        return this.getMainStep();
      case steps.setPermanentStatus:
        return this.getSetPermanentStatusStep();
      case steps.currentPasswordConfirmed:
        return this.getCurrentPasswordConfirmedStep();
      default:
        return this.getMainStep();
    }
  };

  render() {
    const { currentStep } = this.state;
    return (
      <>
        <Modal
          showModal={true}
          hasCloseIcon={this.isFinishedStep()}
          onClose={this.props.updateInfo}
          preventCloseOnEsc
        >
          {this.renderSteps(currentStep)}
        </Modal>
      </>
    );
  }
}
